// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconKey = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M19 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0" />,
    <path
      fillRule="evenodd"
      d="M16.687 11.94q.398.06.813.06a5.5 5.5 0 10-5.307-4.05L2 18.141l4.243 4.243 2.828-2.829 2.121 2.122 4.243-4.243-2.121-2.121zM17.5 3a3.5 3.5 0 00-2.933 5.41l-1.434 1.434-.003-.004-8.302 8.302 1.415 1.414 2.828-2.828 2.121 2.121 1.415-1.414-2.122-2.121 4.862-4.862.004.003.747-.747A3.5 3.5 0 1017.5 3"
    />
  );
export default SvgIconKey;
